jQuery(document).ready(function($) {

	if (window.location.href.includes('shopifypreview')) {
		document.querySelectorAll('.coming-soon').forEach(el => {
		el.classList.add('dnone');
		});
	}

	var owl = $(".collections-slider");
	  owl.owlCarousel({
		items: 4,
		margin: 20,
		loop: true,
		nav: false,
		responsive: {
		  1: {
			items: 1
		  },
		  768: {
			items: 2
		  },
		  1200: {
			items: 3
		  },
		  1530: {
			items: 4
		  }
		},
		autoplay: true,
		slideTransition: 'linear',
        autoplayTimeout: 5000,
        autoplaySpeed: 5000,
        autoplayHoverPause: true,
		dots: false,
	  });	

    var owl = $(".collection-slider");
	  owl.owlCarousel({
		items: 2,
		margin: 20,
		loop: true,
		nav: true,
		responsive: {
		  1: {
			items: 1
		  },
		  1200: {
			items: 2
		  }
		},
		autoplay: false,
        autoplayHoverPause: true,
		dots: false,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0247/6480/9252/files/Vector_10.svg?v=1763033523' alt='Prev'>","<img src='https://cdn.shopify.com/s/files/1/0247/6480/9252/files/Vector_9.svg?v=1763033303' alt='Next'>"]
	  });	

	  var owl = $(".announcement-slider");
	  owl.owlCarousel({
		items: 1,
		margin: 0,
		loop: true,
		nav: false,
		autoplay: true,
        autoplayHoverPause: true,
		dots: false,
	  });

	  var owl = $(".testimonial-slider");
	  owl.owlCarousel({
		items: 1,
		margin: 20,
		loop: true,
		nav: true,
		responsive: {
		  1: {
			items: 1
		  },
		  768: {
			items: 2
		  },
		  1200: {
			items: 3
		  }
		},
		autoplay: false,
        autoplayHoverPause: true,
		dots: false,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0247/6480/9252/files/Vector_10.svg?v=1763033523' alt='Prev'>","<img src='https://cdn.shopify.com/s/files/1/0247/6480/9252/files/Vector_9.svg?v=1763033303' alt='Next'>"]
	  });
	
});